import { useEffect, useState } from 'react'
import { Sparkles } from 'lucide-react'
import { onUpdateAvailable, applyUpdate } from '../lib/sw'

/**
 * Floating toast that appears at the top of the app when a new service
 * worker (= new app version) has been installed and is waiting to take
 * over. Tap "Update" → the waiting SW activates + the page reloads with
 * the latest assets. Same UX as Twitter / Linear / WhatsApp Web.
 */
export default function UpdateToast() {
  const [show, setShow] = useState(false)
  const [applying, setApplying] = useState(false)

  useEffect(() => {
    const off = onUpdateAvailable((available) => setShow(available))
    return off
  }, [])

  if (!show) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed left-1/2 -translate-x-1/2
                 top-[max(env(safe-area-inset-top,0px),0.5rem)] z-[2147483646]
                 flex w-max max-w-[calc(100vw-1rem)] items-center gap-2 px-3 py-2 rounded-full
                 bg-blue-600 text-white shadow-lg text-xs sm:text-sm
                 animate-[fadein_120ms_ease-out]"
    >
      <Sparkles className="w-3.5 h-3.5 shrink-0" aria-hidden />
      <span className="min-w-0 truncate">Update available</span>
      <button
        onClick={async () => {
          setShow(false)
          setApplying(true)
          try { await applyUpdate() } finally { setApplying(false) }
        }}
        disabled={applying}
        className="ml-1 shrink-0 px-2 py-1 rounded-full bg-white/20 hover:bg-white/30
                   text-white text-xs font-medium transition-colors
                   disabled:opacity-60"
      >
        {applying ? 'Updating…' : 'Reload'}
      </button>
      <button
        onClick={() => setShow(false)}
        aria-label="Dismiss"
        className="shrink-0 px-2 py-1 rounded-full hover:bg-white/10 text-xs"
      >
        Later
      </button>
    </div>
  )
}
